import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Mail from '@material-ui/icons/Mail';
import ToolTip from '../../../../../../common/StyledToolTip';

const styles = (theme) => ({
  message: {
    fontSize: '20px',
    cursor: 'pointer',
    color: theme.HeaderSelectedText
  },
  disabledMessage: {
    opacity: 0.6,
    cursor: 'not-allowed'
  }
});

const Message = ({
  classes,
  onClick,
  disabled,
  disabledTooltipMessage = '',
  tooltipMessage = ''
}) => {
  return (
    <ToolTip title={disabled ? disabledTooltipMessage : tooltipMessage} placement="top">
      <Mail
        className={`${classes.message} ${disabled ? classes.disabledMessage : ''}`}
        onClick={disabled ? undefined : onClick}
      />
    </ToolTip>
  );
};

export default withStyles(styles)(Message);
